module.exports = __webpack_public_path__ + "img/backup-help-center-icon.20626ca1.svg";